export const SET_LOADING = 'SET_LOADING'
export const SET_VALID = 'SET_VALID'
export const SET_CREDENTIALS = 'SET_CREDENTIALS'
export const SET_CLIENT = 'SET_CLIENT'
export const RESET_AUTH = 'RESET_AUTH'
